module.exports = __webpack_public_path__ + "img/scenes_9.da0abdff.png";